module.exports = __webpack_public_path__ + "img/北京办公室4.6b366c62.jpg";